import * as jstz from 'jstimezonedetect';

document.addEventListener('DOMContentLoaded', () => {
  const swiperFunc = setSwiperSpeaker();
  const uwb = new UWB({
    toolSmoothScroll: {
      reomveClasses: ['slideout'],
    },
    uaMobileCoverAdjust: {
    uaMobileCoverAdjust: false,
    },
  });

  UWX.MenuActivate('.page_header-menu', '.btn-menu, .page_header-nav');
  UWX.ClickTransfer('.text a', '.page_header-menu');
  if(window.matchMedia('(max-width: 768px)').matches){
    UWX.ScrollLock('.btn-menu, .page_header-nav');
  }

  UWX.FadeIn('.fadein', {
    duration: 0.3,
    delay: 0.3,
    easing: UWX.Easing.EaseInOutSine
  });

  UWX.ScrollActionReferElement('.aono', '.aono', { once: true, });
  UWX.ScrollActionReferElement('.mr_okada', '.mr_okada', { once: true, });
  UWX.ScrollActionReferElement('.global_image', '.global_image', { once: true, });
  UWX.ScrollActionReferElement('.global_copy', '.global_copy', { once: true, });
  
  UWX.ScrollActionReferPosition('.page_header', 200, {
    activeClass: 'slideout',
    sedationLine: -100,
    direction: 'down'
  });
  UWX.ScrollActionReferPosition('.page_header', 400, {
    activeClass: 'actived',
    sedationLine: 0,
    once: false,
    direction: 'both'
  });
  
  setTimeZone();
});

const setTimeZone = () => {
  const targetElms = document.querySelectorAll('.data-item');
  const selectElm = document.querySelector('.timetable-time_zone select');
  const adjustTimeZone = (index) => {
    const optionItem = Array.from(selectElm.querySelectorAll('option'))[index];
    const jpOffset = Number(optionItem.dataset.tzjoffset);

    Array.from(targetElms).forEach((item) => {
      const baseObj = item.querySelector('.time_jp').textContent.split('：')[1].split('〜');
      
      const baseStartArr = baseObj[0].split(':');
      const baseStartVal = Number(baseStartArr[0]) * 60 + Number(baseStartArr[1]);
      const startVal = baseStartVal + (jpOffset * 60);

      const baseEndArr = baseObj[1].split(':');
      const baseEndVal = Number(baseEndArr[0]) * 60 + Number(baseEndArr[1]);
      const endVal = baseEndVal + (jpOffset * 60);

      item.querySelector('.time_start time').textContent = `${getFormatedTime(startVal)}`;
      item.querySelector('.time_end time').textContent = `${getFormatedTime(endVal)}`;
      Array.from(item.querySelectorAll('.time_code span')).forEach((codeItem) => {
        codeItem.textContent = optionItem.textContent;
      });
    });

    const infoTime = document.querySelector('section.info .time');
    const infoObj = infoTime.querySelector('.jp_time').textContent.split(' ')[1].split('～');

    const infoStartArr = infoObj[0].split(':');
    const infoStartVal = Number(infoStartArr[0]) * 60 + Number(infoStartArr[1]);
    const infoStart = infoStartVal + (jpOffset * 60);

    const infoEndArr = infoObj[1].split(':');
    const infoEndVal = Number(infoEndArr[0]) * 60 + Number(infoEndArr[1]);
    const infoEnd = infoEndVal + (jpOffset * 60);

    infoTime.querySelector('.start').textContent = `${getFormatedTime(infoStart)}`;
    infoTime.querySelector('.end').textContent = `${getFormatedTime(infoEnd)}`;
    infoTime.querySelector('.zone').textContent = `${optionItem.textContent}`;
  }

  const getFormatedTime = (val) => {
    const h = Math.trunc(val / 60);
    const m = val - (h * 60);
    return `00${h}`.slice(-2) + `:` + `00${m}`.slice(-2);
  }

  const tzOffset = (jstz.determine().offsets[0] / 60);
  const optIndex = Array.from(selectElm.querySelectorAll('option')).findIndex((item, i) => {
    const itemOffset = item.dataset.tzjoffset;
    const itemTzOffset = Number(itemOffset) + 9;
    return tzOffset === itemTzOffset;
  });

  if(-1 < optIndex){
    const defaultSelected = selectElm.querySelector('option[selected]');
    defaultSelected.removeAttribute('selected');
    const optItem = Array.from(selectElm.querySelectorAll('option'))[optIndex];
    optItem.setAttribute('selected', 'true');
    adjustTimeZone(optIndex);
  }else{
    const defaultIndex = Array.from(selectElm.querySelectorAll('option')).findIndex((item, i) => {
      return item.hasAttribute('selected');
    });
    adjustTimeZone(defaultIndex);
  }

  selectElm.addEventListener('change', (e) => {
    const selectedIndex = e.target.selectedIndex;
    adjustTimeZone(selectedIndex);
  });
}

const setSwiperSpeaker = () => {
  return new Swiper('.sliderSpeaker', {
    loop: true,
    speed: 1000,
    slidesPerView: 'auto',
    spaceBetween: 60,
    direction: 'horizontal',
    freeMode: true,
    centeredSlides : true,
    autoplay: {
      delay: 3000,
      stopOnLast: false,
      disableOnInteraction: false
    },
    breakpoints: {
      321: {
        spaceBetween: 30
      },
      768: {
        spaceBetween: 60
      },
    },
  });
}
